import { useEffect, useState } from 'react'
import { usePartnerContext } from '../../../utils/contexts/partner/PartnerContext.hooks'
import { PartnerType } from '../../../exports/utils'
import clientEnv from '../../../utils/global/clientEnv'
import { detectUserRegion, getLocalizedLegalLinks } from '../../../components/privacy-compliance'

// v3-only copy of `nav-v2/components/HelpMenu/hooks/useHelpMenuLinks.ts`. The
// nav-v2 hook will be removed when v2 retires; until then, v2 and v3 keep
// independent code paths so v3-specific changes don't alter the v2 menu.
//
// Difference from the v2 hook: no Partner Status link. In v3 the System Status
// page is reached via Settings → Platform management instead of the help menu.
export type TdsHelpMenuLink = {
  href?: string
  messageId: string
  onClick?: () => void
  openInNewTab?: boolean
}

export const useTdsHelpMenuLinks = () => {
  const partnerContext = usePartnerContext()

  const [legalLinks, setLegalLinks] = useState(() => getLocalizedLegalLinks(null))

  useEffect(() => {
    const updateLegalLinks = async () => {
      const region = await detectUserRegion()
      const localizedLinks = getLocalizedLegalLinks(region.countryCode)
      setLegalLinks(localizedLinks)
    }

    void updateLegalLinks()
  }, [])

  const docsUrl =
    partnerContext.partnerType === PartnerType.IDP
      ? 'https://docs.instacart.com/developer_platform_api/'
      : clientEnv.PUBLIC_CLIENT_PARTNER_DOCS_URL

  const termsUrl =
    partnerContext.partnerType === PartnerType.IDP
      ? 'https://docs.instacart.com/developer_platform_api/guide/terms_and_policies/developer_terms/'
      : legalLinks.termsUrl

  const links: TdsHelpMenuLink[] = [
    { href: docsUrl, messageId: 'navV2.userSettings.documentation' },
    { href: 'https://instacart.com/press', messageId: 'press' },
    { href: legalLinks.privacyUrl, messageId: 'privacy' },
    { href: 'https://instacart.safebase.us/', messageId: 'security_and_trust' },
    { href: termsUrl, messageId: 'terms' },
    {
      href: 'https://instacart.atlassian.net/servicedesk/customer/portal/1',
      messageId: 'service_desk',
    },
  ]

  return links
}
